export class CreditCard {
    nameOnCard: string;
    email: string;
    creditCardNumber: string;
    cvv: string;
    expirationMonth: string;
    expirationYear: string;
    zipCode: string;

    constructor(nameOnCard: string, email: string, creditCardNumber: string, cvv: string,
                expirationMonth: string, expirationYear: string, zipCode: string) {
        this.nameOnCard = nameOnCard;
        this.email = email;
        this.creditCardNumber = creditCardNumber;
        this.cvv = cvv;
        this.expirationMonth = expirationMonth;
        this.expirationYear = expirationYear;
        this.zipCode = zipCode;
    }
}
